// extracted by mini-css-extract-plugin
export default {"portalWrapper":"portalWrapper__1dkOg"};